import { memo } from 'react'

import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'

const GeneratingMentorView: React.FC = memo(() => (
  <div className="px-6 py-8">
    <div className="flex flex-col items-center justify-center h-full">
      <div className="h-12 w-12 rounded-full bg-[#78788C] text-white flex items-center justify-center">
        <AnimatedSpinner />
      </div>
      <div className="text-white text-xl my-2">Generating companion</div>
      <div className="text-[#F2F2F4] text-sm">
        Please wait while we create the companion profile.
      </div>
    </div>
  </div>
))

export { GeneratingMentorView }
